<template>
    <div class="search-result document-result">
        <template v-if="result && !isDeleted">
            <div v-if="!noHr" class='hr-line-dashed'></div>
            <div class="row">
                <div class="col-sm-12 col-md-8">
                    <h3 class="document-result-headline">
                        <a :href="showUrl()">
                            {{ result.name }}
                        </a>
                        <span v-if="result.coaches_only" class="document-result-pill">
                            <i class="fa-solid fa-lock" aria-hidden="true"></i> Coaches only
                        </span>
                        <span v-if="showSigningFrequency" class="document-result-pill">
                            <i class="fa-solid fa-pencil" aria-hidden="true"></i> {{ signingFrequencyLabel }}
                        </span>
                        <span v-if="showAttachScope && result.auto_attach_to_sessions" class="document-result-pill is-universal">
                            <i class="fa-solid fa-earth-americas" aria-hidden="true"></i> Used in all registrations
                        </span>
                        <span v-else-if="showAttachScope" class="document-result-pill is-scoped">
                            <i class="fa-solid fa-link" aria-hidden="true"></i> Used in specific registrations
                        </span>
                    </h3>
                </div>
                <div class="col-sm-12 col-md-4 card-actions document-result-actions">
                    <copy-icon :text="shareUrl()" class="m-r-sm"></copy-icon>
                    <span v-if="showDelete">
                        <a :href="editUrl()" class="m-r-sm">
                            Edit
                        </a>
                        <a class="m-r-sm" @click.prevent="showDocumentDeleteForm()">
                            Delete
                        </a>
                        <a v-if="showSignAgain" @click.prevent="showSignAgainForm()" class="m-r-sm">
                            Sign again
                        </a>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <delete-document-form v-show="deleteDocumentForm" :document="result"></delete-document-form>
                    <sign-again-form v-show="signAgainForm" :document="result"></sign-again-form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CopyIcon from './copy_icon.vue';
import DeleteDocumentForm from './delete_document_form.vue';
import SignAgainForm from './sign_again_form.vue';

export default {
  name: 'document-result',
  components: { CopyIcon, SignAgainForm, DeleteDocumentForm },
  props: [
    'result',
    'showEdit',
    'showDelete',
    'noHr',
  ],
  data() {
    return {
      deleteDocumentForm: false,
      signAgainForm: false,
      showSignAgain: false,
      isDeleted: false,
    };
  },
  computed: {
    showSigningFrequency() {
      return (this.result.needs_signature || this.result.liability_form)
        && !!this.result.signing_frequency;
    },
    signingFrequencyLabel() {
      if (this.result.signing_frequency === 'every_registration') {
        return 'Signed every registration';
      }
      return 'Signed once';
    },
    showAttachScope() {
      return !!(this.result.needs_signature || this.result.liability_form);
    },
  },
  created() {
    const vm = this;
    vm.showSignAgain = (vm.result.needs_signature && vm.showEdit);

    vm.$notificationManager.on('hide-delete-document-form', vm.hideListener);
    vm.$notificationManager.on('document-deleted', vm.documentDeletedListener);

    vm.$notificationManager.on('hide-sign-again-document-form', vm.hideListener);
    vm.$notificationManager.on('document-sign-again', vm.hideListener);
  },
  destroyed() {
    const vm = this;
    vm.$notificationManager.off('hide-delete-document-form', vm.hideListener);
    vm.$notificationManager.off('document-deleted', vm.documentDeletedListener);

    vm.$notificationManager.off('hide-sign-again-document-form', vm.hideListener);
    vm.$notificationManager.off('document-sign-again', vm.hideListener);
  },
  methods: {
    hideListener(doc) {
      const vm = this;
      if (vm.result.id === doc.id) {
        vm.hideDocumentDeleteForm();
        vm.hideSignAgainForm();
      }
    },
    showUrl() {
      return `/documents/${this.result.id}`;
    },
    shareUrl() {
      return `${window.location.origin}${this.showUrl()}`;
    },
    editUrl() {
      return `/documents/${this.result.id}/edit`;
    },
    documentDeletedListener(doc) {
      const vm = this;
      if (vm.result.id === doc.id) {
        vm.hideDocumentDeleteForm();
        vm.isDeleted = true;
      }
    },
    showDocumentDeleteForm() {
      this.deleteDocumentForm = true;
    },
    hideDocumentDeleteForm() {
      this.deleteDocumentForm = false;
    },
    showSignAgainForm() {
      this.signAgainForm = true;
    },
    hideSignAgainForm() {
      this.signAgainForm = false;
    },
  },
};
</script>
